import type { LinkResolverFunction } from "@prismicio/helpers"
import {
  asHTML as asHTMLHelper,
  asText as asTextHelper,
} from "@prismicio/helpers"
import type { RichTextField } from "@prismicio/types"

import type { Maybe } from "~/types/ts-utils"

export const asText = (richText: Maybe<RichTextField>): string => {
  return asTextHelper(richText || []) || ""
}

export const asHTML = (
  richText: Maybe<RichTextField>,
  linkResolver?: LinkResolverFunction,
): string => {
  return asHTMLHelper(richText || [], linkResolver || undefined) || ""
}
